import React from 'react';
import Styles from "./styles.module.scss";

const Divider = props => (<div className={`${Styles['divider']} mt-20 mb-30`}></div>)


export default Divider;